import { DialogId } from '@feedyou/schema'
import { mergeSets } from '@feedyou/utils'

import { TreeEntryPoint } from './getUsedDialogsPerTreeEntryPoint'
import { DialogHierarchyMap } from './buildDialogHierarchyMap'

export const getEntryPointsThroughWhichDialogIsAccessible = (
  id: DialogId,
  hierarchyMap: DialogHierarchyMap
): Set<TreeEntryPoint> => {
  const idsOfInterest = [id, ...(hierarchyMap.get(id)?.enabledConnectionsOnly.ancestors ?? [])]

  function getParentEntryPoints(dialogId: DialogId) {
    return hierarchyMap.get(dialogId)?.parentEntryPoints || new Set()
  }

  return mergeSets(idsOfInterest.map(getParentEntryPoints))
}
